import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { SupplierDto } from '@api/models/suppliers/SupplierDto';
import { SupplierState } from '@api/models/enums/SupplierState';
import { supplierEmployeeService, supplierService } from '@api/services/services';

type State = BaseType<SupplierDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    ico: '',
    vat: '',
    state: SupplierState.Active,
    address: {
      street: '',
      city: '',
      postalCode: '',
      country: '',
    },
    note: '',
  },
};

export const supplierSlice = baseSlice({
  name: 'supplier',
  initialState,
});

export const selectSupplierState = (state: RootState) => state.supplier.state;
export const selectSupplier = (state: RootState) => state.supplier.data;
export const supplierActions = supplierSlice.actions;

export const getSupplier = (supplierId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return supplierService.getById(supplierId);
  };

  getItem({
    dispatch,
    actions: supplierActions,
    getData: handleGetData,
  });
};

export const getSupplierFromUserId = (userId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return supplierEmployeeService.getSupplierFromUserId(userId);
  };

  getItem({
    dispatch,
    actions: supplierActions,
    getData: handleGetData,
  });
};
